<template>
  <svg viewBox="0 0 16 16"><path fill-rule="nonzero" d="M15.347 1.22l-.067.074-6.469 6.47 6.47 6.47a.75.75 0 01-.977 1.132l-.084-.072-6.47-6.47-6.47 6.47a.75.75 0 01-1.133-.977l.073-.084 6.469-6.47-6.47-6.47A.75.75 0 011.197.162l.084.072 6.47 6.47 6.47-6.47.074-.067c.653-.526 1.53.306 1.11.974l-.057.08z" /></svg>
</template>

<script>
export default {
  name: 'Decline'
}
</script>
